import { isAccountAllowed } from '$lib/components/permission/permission'
import { UserRole } from '$lib/components/role/role'
import { membership } from '$lib/domain/membership/membership'
import { tenantSettings } from '$lib/domain/tenantSettings/tenantSettings'
import { affiliatePlatformLock } from './affiliatePlatformLock'
import { pendingSettings } from './pendingSettings'
import { EnumsV1Permission, MembershipsV1PlanId, SettingsV1OnboardingStatus } from '@sdk/Api'
import { derived } from '@square/svelte-store'
import { account, impersonatedAccount } from '@store/account'
import { writable } from 'svelte/store'

export const onboardingStatus = writable(SettingsV1OnboardingStatus.ONBOARDING_STATUS_INITIAL)

export const onboardingPlatformLock = derived(
	[
		onboardingStatus,
		pendingSettings,
		affiliatePlatformLock,
		account,
		impersonatedAccount,
		membership,
		tenantSettings,
	],
	([
		$onboardingStatus,
		$pendingSettings,
		$affiliatePlatformLock,
		$account,
		$impersonatedAccount,
		$membership,
		$tenantSettings,
	]) => {
		return (
			($account?.role.name === UserRole.Affiliate &&
				$tenantSettings.affiliatePendingSettingsPlatformLock &&
				!$impersonatedAccount &&
				$affiliatePlatformLock === 'locked') ||
			(isAccountAllowed(EnumsV1Permission.PERMISSION_VIEW_GETTING_STARTED, $account) &&
				$onboardingStatus ===
					SettingsV1OnboardingStatus.ONBOARDING_STATUS_SELF_IMPLEMENTATION_APP_LOCKED &&
				$membership.planId === MembershipsV1PlanId.PLAN_ID_FREEMIUM &&
				$pendingSettings)
		)
	},
)
